import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78044692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "platforms ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "expected length ", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "reserved ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "status ", -1))
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      style: {"padding":"15px","margin-left":"20px","margin-right":"20px","margin-top":"10px","margin-bottom":"20px"},
      class: "article"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.bounty?.name), 1)
        ]),
        (_ctx.details?.imageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "centered",
              src: _ctx.details?.imageUrl
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider, { style: {"margin":"8px"} }),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details?.platforms, (platform) => {
              return (_openBlock(), _createElementBlock("span", { key: platform }, _toDisplayString(platform) + " ", 1))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.details?.gameplayMainExtra || '') + " ", 1),
            (_ctx.details?.gameplayMainExtra)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "hours"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.bounty?.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(_ctx.bounty?.reservedUser), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createElementVNode("span", null, _toDisplayString(_ctx.bounty?.status), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_timeline, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
              return (_openBlock(), _createBlock(_component_v_timeline_item, {
                key: action.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getActionTime(action)), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.getActionType(action)), 1)
                    ])
                  ]),
                  (action?.data?.text || _ctx.isApproval(action))
                    ? (_openBlock(), _createBlock(_component_v_card, {
                        key: 0,
                        color: "blue-grey-darken-4",
                        style: {"padding":"8px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(action?.data?.text), 1),
                          (action?.data?.video)
                            ? (_openBlock(), _createElementBlock("video", {
                                key: action?.data?.video,
                                controls: ""
                              }, [
                                _createElementVNode("source", {
                                  src: action?.data?.video,
                                  type: "video/mp4"
                                }, null, 8, _hoisted_12)
                              ]))
                            : _createCommentVNode("", true),
                          (!action.completed)
                            ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 1 }, {
                                default: _withCtx(() => [
                                  (_ctx.isAdmin && _ctx.isApproval(action))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.actionInProgress,
                                          onClick: ($event: any) => {_ctx.approve(action);},
                                          color: "green",
                                          variant: "tonal",
                                          elevation: "4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Approve")
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"]),
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.actionInProgress,
                                          onClick: ($event: any) => {_ctx.reject(action);},
                                          color: "warning",
                                          variant: "tonal",
                                          elevation: "4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Reject")
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isAdmin && _ctx.isPendingPayment(action))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.actionInProgress,
                                          onClick: ($event: any) => {_ctx.markPaid(action);},
                                          color: "warning",
                                          variant: "tonal",
                                          elevation: "4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Pay")
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isPendingSubmit(action) && _ctx.user === action?.actionuser)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createVNode(_component_v_dialog, {
                                          transition: "dialog-top-transition",
                                          width: "auto"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_tooltip, { text: "Submit Video" }, {
                                              activator: _withCtx(({ props: tooltip }) => [
                                                _createVNode(_component_v_btn, _mergeProps(_ctx.mergeProps(props, tooltip), {
                                                  disabled: _ctx.actionInProgress,
                                                  color: "green",
                                                  variant: "tonal",
                                                  elevation: "4"
                                                }), {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Submit")
                                                  ]),
                                                  _: 2
                                                }, 1040, ["disabled"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          default: _withCtx(({ isActive }) => [
                                            _createVNode(_component_v_card, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_toolbar, {
                                                  color: "primary",
                                                  title: _ctx.bounty.name + ' Video'
                                                }, null, 8, ["title"]),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("input", {
                                                      type: "file",
                                                      ref_for: true,
                                                      ref: "file",
                                                      multiple: "",
                                                      name: "files[]",
                                                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
                                                    }, null, 544),
                                                    (_ctx.progress)
                                                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                                          key: 0,
                                                          "v-model": _ctx.progress
                                                        }, null, 8, ["v-model"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      variant: "text",
                                                      onClick: ($event: any) => (isActive.value = false)
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Cancel")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]),
                                                    _createVNode(_component_v_btn, {
                                                      variant: "text",
                                                      onClick: ($event: any) => {_ctx.submit(action,isActive);}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Submit")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.actionInProgress,
                                          onClick: ($event: any) => {_ctx.abandon(action);},
                                          color: "warning",
                                          variant: "tonal",
                                          elevation: "4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Abandon")
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}